'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface QRCodeVerificationProps {
  orderId: string;
  batchNumber: string;
}

const QRCodeVerification = ({ orderId, batchNumber }: QRCodeVerificationProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [showQR, setShowQR] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-elevation-md p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/2 mb-4"></div>
          <div className="h-32 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-6">
      <h2 className="font-heading text-xl font-semibold text-foreground mb-4">
        Verification & Traceability
      </h2>

      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
          <div className="flex items-center gap-3">
            <Icon name="QrCodeIcon" size={24} className="text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">Delivery QR Code</p>
              <p className="text-xs text-muted-foreground">Show to delivery partner</p>
            </div>
          </div>
          <button
            onClick={() => setShowQR(!showQR)}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium transition-smooth hover:shadow-elevation-md"
          >
            {showQR ? 'Hide' : 'Show'}
          </button>
        </div>

        {showQR && (
          <div className="flex flex-col items-center p-6 bg-background rounded-lg border-2 border-dashed border-border">
            <div className="w-48 h-48 bg-white rounded-lg flex items-center justify-center mb-4">
              <svg
                width="192"
                height="192"
                viewBox="0 0 192 192"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="192" height="192" fill="white" />
                <rect x="16" y="16" width="48" height="48" fill="black" />
                <rect x="128" y="16" width="48" height="48" fill="black" />
                <rect x="16" y="128" width="48" height="48" fill="black" />
                <rect x="32" y="32" width="16" height="16" fill="white" />
                <rect x="144" y="32" width="16" height="16" fill="white" />
                <rect x="32" y="144" width="16" height="16" fill="white" />
                <rect x="80" y="80" width="32" height="32" fill="black" />
              </svg>
            </div>
            <p className="font-data text-sm text-center text-muted-foreground">
              Order ID: {orderId}
            </p>
          </div>
        )}

        <div className="flex items-center justify-between p-4 bg-muted rounded-lg">
          <div className="flex items-center gap-3">
            <Icon name="ShieldCheckIcon" size={24} className="text-success" />
            <div>
              <p className="text-sm font-medium text-foreground">Batch Traceability</p>
              <p className="font-data text-xs text-muted-foreground">Batch: {batchNumber}</p>
            </div>
          </div>
          <button className="px-4 py-2 bg-muted text-foreground border border-border rounded-md text-sm font-medium transition-smooth hover:bg-border">
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeVerification;